import { useEffect } from 'react'
import { notification } from 'shared/assets/sounds'
import { logger } from 'shared/lib'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventMessagePopper } from 'entities/Message/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

const notificationAudio = notification.getAudio('notification')

export const useEventMessagePopper = () => {
  const { inboxesStore, usersStore, websocket } = useEntitiesContext()
  const handle = (data: IResponseEventMessagePopper) => {
    const inbox = inboxesStore.getItem(data.inbox_id)
    const { isAwayStatus } = usersStore

    if (inbox && !inbox.isMuted && !isAwayStatus) {
      notificationAudio.play().catch(logger.error)
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.MessagePopper, handle), [])
}
